export const russian = {
  months: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
  ],
  weekDays: [
    {
      name: 'Понедельник',
      short: 'Пн',
    },
    {
      name: 'Вторник',
      short: 'Вт',
    },
    {
      name: 'Среда',
      short: 'Ср',
    },
    {
      name: 'Четверг',
      short: 'Чт',
    },
    {
      name: 'Пятница',
      short: 'Пт',
    },
    {
      name: 'Суббота',
      short: 'Сб',
      isWeekend: true,
    },
    {
      name: 'Воскресенье',
      short: 'Вс',
      isWeekend: true,
    },
  ],

  weekStartingIndex: -1,

  getToday(gregorainTodayObject) {
    return gregorainTodayObject;
  },

  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
  },

  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate();
  },

  transformDigit(digit) {
    return digit;
  },
}